import React, { memo } from 'react'
import styles from './NotFoundProductList.module.scss'

type Props = {}

const NotFoundProductList: React.FC<Props> = memo((props: Props) => {
    return (
        <div className={styles.notFoundContainer}>
            <img src='/icons/not-found-magnifier.svg' alt="Best Offer" className={styles.notFoundImage} />
            <div className={styles.notFoundTextContainer}>
                <div className={styles.notFoundText}>
                    No products found
                </div>
                <div className={styles.notFoundSubtitle}>
                    Please try different parameters
                </div>
            </div>
        </div>
    )
})

export default NotFoundProductList